import { combineReducers } from 'redux';
import { getCoreDataSecurityMonitorsAllSlice } from './get';
import { removeCoreDataSecurityMonitorsAllSyncSlice } from './remove';
import { updateCoreDataSecurityMonitorsAllSyncSlice } from './update';

import { combineAllWatchers, joinReducers } from '@sonar-software/xuder';

export const coreDataSecurityMonitorsAllReducers = combineReducers({
	get: joinReducers([
		getCoreDataSecurityMonitorsAllSlice.asyncReducers,
		updateCoreDataSecurityMonitorsAllSyncSlice.syncReducer,
		removeCoreDataSecurityMonitorsAllSyncSlice.syncReducer
	],
	getCoreDataSecurityMonitorsAllSlice.asyncState)
});

export const coreDataSecurityMonitorsAllWatchers = combineAllWatchers([
	getCoreDataSecurityMonitorsAllSlice.asyncWatchers
]);
